import constant from "../../constant";
const resource = constant.api + "payments";

const state = {
  payments: [],
  payment: {},
};

// getters
const getters = {
  getAll: (state) => {
    return state.payments;
  },
  getPayment: (state) => {
    return state.payment;
  },
};

// actions
const actions = {
  async getAll({ commit }) {
    const response = await this._vm.$api.fetch(resource);
    const data = Array.isArray(response) ? response : response?.data || [];
    commit("setAll", data);
    return data;
  },

  async show({ commit }, reference) {
    const response = await this._vm.$api.show(`${resource}/${reference}`);
    // Extract data from response - handle both nested and direct responses
    let data = null;
    if (response && typeof response === "object") {
      if (response.data) {
        data = response.data;
      } else if (Array.isArray(response)) {
        data = response[0] || response;
      } else {
        data = response;
      }
    }
    commit("setPayment", data);
    return data;
  },

  async store({ commit, dispatch }, data) {
    const response = await this._vm.$api.create(resource, data);
    await dispatch("getAll");
    return response;
  },

  async update({ commit, dispatch }, { reference, data }) {
    const response = await this._vm.$api.update(
      `${resource}/${reference}`,
      data
    );
    await dispatch("getAll");
    return response;
  },

  async destroy({ commit, dispatch }, reference) {
    const response = await this._vm.$api.delete(`${resource}/${reference}`);
    await dispatch("getAll");
    return response;
  },
};

// mutations
const mutations = {
  setAll(state, data) {
    state.payments = Array.isArray(data) ? data : [];
  },

  setPayment(state, data) {
    if (!data) {
      state.payment = {};
      return;
    }
    if (
      data.data &&
      typeof data.data === "object" &&
      !Array.isArray(data.data)
    ) {
      state.payment = data.data;
    } else if (typeof data === "object" && !Array.isArray(data)) {
      state.payment = data;
    } else {
      state.payment = {};
    }
  },

  resetPayment(state) {
    state.payment = {};
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

